// Reservations action types

const reservationsActionTypes = {
  GET_RESERVATION_INFO_SUCCESS: 'GET_RESERVATION_INFO_SUCCESS',
  GET_RESERVATION_INFO_LOADING: 'GET_RESERVATION_INFO_LOADING',
  GET_RESERVATION_INITIAL_INFO_LOADING: 'GET_RESERVATION_INITIAL_INFO_LOADING',
  GET_RESERVATION_INFO_ERROR: 'GET_RESERVATION_INFO_ERROR',
  GET_RESERVATION_INFO_FINISH: 'GET_RESERVATION_INFO_FINISH',
  CREATE_RESERVATION_LOADING: 'CREATE_RESERVATION_LOADING',
  CREATE_RESERVATION_ERROR: 'CREATE_RESERVATION_ERROR',

  CLEAR_RESERVATION_ERROR: 'CLEAR_RESERVATION_ERROR',
  SET_RESERVATION_LAST_NAME_FIND_BY_ID: 'SET_RESERVATION_LAST_NAME_FIND_BY_ID',
  SET_RESERVATION_KEY_FIND_RESERVATION_BY_ID: 'SET_RESERVATION_KEY_FIND_RESERVATION_BY_ID',
  GTM_RESERVATION_NEW_OR_DAYPASS: 'GTM_RESERVATION_NEW_OR_DAYPASS'
};

export default reservationsActionTypes;
